var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 36C30 31.5817 33.5817 28 38 28H62C77.464 28 90 40.536 90 56C90 71.464 77.464 84 62 84H48C38.6112 84 31 76.3888 31 67V44H50V66C50 70.4183 53.5817 74 58 74H62C71.9411 74 80 65.9411 80 56C80 46.0589 71.9411 38 62 38H30V36Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58 44H76C86.4934 44 95 52.5066 95 63C95 73.4934 86.4934 82 76 82H58V44Z",
    fill: "currentColor",
    opacity: 0.78
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 52H58V66C58 73.732 51.732 80 44 80V52Z",
    fill: "currentColor",
    opacity: 0.52
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRender);
export default __webpack_public_path__ + "static/media/render.1080c4560abdac4cbb05056bc61958c5.svg";
export { ForwardRef as ReactComponent };